import { ActionTree, GetterTree, MutationTree } from "vuex";
import { AssistWriterType } from "@/lib/models/assist";
import { AssistantCatClient } from "@/lib/clients/assistantCatClient";
import {
  AssistantCatMaster,
  AssistantCat,
  UpdateAssistantCatMasterInput,
  UpdateAssistantCatInput,
} from "@/lib/models/assistantCat";

const assistantCatClient = new AssistantCatClient();

export interface AssistantCatState {
  selectedType: AssistWriterType | null;
  serializedResult: string | null;
  assistantCatMaster: AssistantCatMaster | null;
  assistantCats: AssistantCat[];
}

const getters: GetterTree<AssistantCatState, {}> = {
  selectedType: (state) => state.selectedType,
  serializedResult: (state) => state.serializedResult,
  assistantCatMaster: (state) => state.assistantCatMaster,
  assistantCats: (state) => state.assistantCats,
};

const mutations: MutationTree<AssistantCatState> = {
  setSelectedType(state, selectedType: AssistWriterType | null) {
    state.selectedType = selectedType;
  },
  setSerializedResult(state, serializedResult: string | null) {
    state.serializedResult = serializedResult;
  },
  setAssistantCatMaster(state, assistantCatMaster: AssistantCatMaster | null) {
    state.assistantCatMaster = assistantCatMaster;
    if (assistantCatMaster) {
      state.selectedType = assistantCatMaster.selectedType;
      state.serializedResult = assistantCatMaster.serializedResult || null;
    }
  },
  setAssistantCats(state, assistantCats: AssistantCat[]) {
    state.assistantCats = assistantCats;
  },
  updateAssistantCatInList(state, updatedCat: AssistantCat) {
    const index = state.assistantCats.findIndex(
      (cat) => cat.assistantCatType === updatedCat.assistantCatType
    );
    if (index !== -1) {
      state.assistantCats.splice(index, 1, updatedCat);
    }
  },
};

const actions: ActionTree<AssistantCatState, {}> = {
  setSelectedCat({ commit }, { selectedType, serializedResult = null }) {
    commit("setSelectedType", selectedType);
    commit("setSerializedResult", serializedResult);
  },
  async fetchAssistantCatMaster({ commit }) {
    const master = await assistantCatClient.getAssistantCatMaster();
    commit("setAssistantCatMaster", master);
    return master;
  },
  async fetchAssistantCatList({ commit }) {
    const cats = await assistantCatClient.listAssistantCat();
    commit("setAssistantCats", cats);
    return cats;
  },
  async updateSelectedCat({ commit }, input: UpdateAssistantCatMasterInput) {
    const updatedMaster = await assistantCatClient.updateAssistantCatMaster(input);
    commit("setAssistantCatMaster", updatedMaster);
    return updatedMaster;
  },
  async updateCatNickname({ commit }, input: UpdateAssistantCatInput) {
    const updatedCat = await assistantCatClient.updateAssistantCat(input);
    commit("updateAssistantCatInList", updatedCat);
    return updatedCat;
  },
};

const state: AssistantCatState = {
  selectedType: null,
  serializedResult: null,
  assistantCatMaster: null,
  assistantCats: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
